<template>
  <v-sheet theme="dark">
    <v-img
      :src="photoPaintBooth"
      content-class="d-flex align-center"
      cover
      gradient="to top right, rgba(38, 50, 56, 0.9), rgba(38, 50, 56, 0.9)"
      max-height="720"
    >
      <v-container>
        <v-row>
          <v-col>
            <h2 class="text-h3 text-md-h2 text-center font-weight-bold">
              About Us
            </h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p class="text-body-1 mb-3">
              West Wind Automotive, also known as Dynamic Motors, is an
              automotive repair facility in San Francisco. Founded in 1979 by
              Nissim Ninio, West Wind Automotive is known for being a family
              owned and operated business servicing the San Francisco Bay Area
              for over 47 years.
            </p>
            <p class="text-body-1 mb-3">
              Conveniently located minutes away from Downtown San Francisco,
              West Wind Automotive strives to offer you impeccable auto body and
              collision repair services to return your vehicle to its
              pre-accident condition.
            </p>
            <p class="text-body-1">
              We aim to make the repair process as easy and painless as possible
              in order to get you back on the road in a timely manner. We
              monitor cars before, during, and after the auto body repairs so
              that all car owners can be assured that the repairs to their
              vehicle are done to factory specifications or better. West Wind's
              repair facility offers the most complete care for you and your
              vehicle. Our repair technicians are
              <a class="text-white" href="http://www.i-car.com/" target="_blank"
                >I-CAR</a
              >
              certified (factory trained), and our facility is stocked with the
              latest industry standard equipment; CCC One, computerized frames,
              computerized paint matching, and a climate controlled downdraft
              spray booth.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
  </v-sheet>
</template>

<script setup lang="ts">
import photoPaintBooth from '#root/assets/images/photo-paint-booth.jpg'
</script>
